<div class="order-top-sec" (window:resize)="onresize($event)">
  <div class="row listing-action-items grower-page">

    <div class="col-md-8 col-sm-12 margin-b10">
      <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                    [ngClass]="{'disabledRow': disableOnLock == true}"
                    [style.display]="disableOnLock || disablecheckbox || isReadOnly || accessTypeMode ? 'none' : 'block'"
                    [checked]="filterGrowerOrderDSitems.length > 0 && (selectedCount > 0) && (selectedCount == filterGrowerOrderDSitems.length)"
                    [indeterminate]="filterGrowerOrderDSitems.length > 0 && (selectedCount > 0) && (selectedCount < filterGrowerOrderDSitems.length)"
                    (change)="EnableAllEditToolKit(Allcheck._checked)"
                    matTooltip="Select All Lines" [matTooltipPosition]="'above'"></mat-checkbox>
      <div class="product-tools-outer" *ngIf="(selectedCount>0) && (!isSearchClicked && editToolKit)">
        <div class="product-tools-tab position-sm-relative" appClickOutside (clickOutside)="tabNode=''">

          <div class="tab-bar col-md-10 padding-sm-l0">
            <ul>
              <li (click)="showTab('delivery')" [ngClass]="{'active': tabNode==='delivery'}" class="seperator margin-sm-r5" matTooltip="Set Delivery Date" [matTooltipPosition]="'above'" id="btnSetDeliveryDate">
                <i class="icon-ico-delivery"></i>
              </li>
              <li (click)="showTab('banned')" [ngClass]="{'active': tabNode==='banned'}" class="seperator d-none d-lg-block" matTooltip="Modify Product" [matTooltipPosition]="'above'" *ngIf="buttonType == 'edit'">
                <i class="icon-ico-replace"></i>
              </li>
              <li (click)="openOrderTransferSliderModel()" class="seperator d-none d-lg-block" matTooltip="Transfer Product on Same Dealer" [matTooltipPosition]="'above'" *ngIf="buttonType == 'edit'">
                <i class="icon-ico-transfer"></i>
              </li>
              <li class="diffDealer seperator d-none d-lg-block" (click)="openDiffDealerGrowerTransferSliderModel()" matTooltip="Transfer Product to Different Dealer" [matTooltipPosition]="'above'" *ngIf="buttonType == 'edit'">
                <i class="fas fa-exchange-alt"></i>
              </li>
              <li (click)="showTab('seller')" [ngClass]="{'active': tabNode==='seller'}" class="seperator margin-sm-r5" matTooltip="Update Seller" [matTooltipPosition]="'above'" id="updateSeller">
                <i class="icon-ico-seller"></i>
              </li>
              <li (click)="showTab('PO')" [ngClass]="{'active': tabNode==='PO'}" class="seperator margin-sm-r5" matTooltip="Update Customer PO" [matTooltipPosition]="'above'" id="UpdateCustomerPO">
                <i class="icon-ico-po"></i>
              </li>
              <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator margin-sm-r5" matTooltip="Delete Items from Order" [matTooltipPosition]="'above'" id="deleteItemsfromOrder">
                <i class="icon-ico-trash"></i>
              </li>
              <li *ngIf="selectedCount>0 && isSearchClicked==false" (click)="isSearchClicked=true;" class="seperator margin-sm-r5" matTooltip="Search your order" [matTooltipPosition]="'above'">
                <i class="icon-ico-Search"></i>
              </li>
            </ul>
          </div>

          <div class="tab-content">
            <div *ngIf="tabNode==='seller'" class="salesPersonOuter">
              <div class="tab-content-heading headtabPadding">
                Set Seller for Grower
              </div>
              <div class="tab-content-detail">
                <div class="sales-person">
                  <div class="default-select sales-person-search">
                    <ng-select name="ddlSellerData"
                               [items]="sellerData"
                               [virtualScroll]="true"
                               bindLabel="accountName"
                               bindValue="accountNumber"
                               placeholder="Search for Seller"
                               [(ngModel)]="sellerId"
                               class="custom-select-grower"
                               (change)="SellerChange($event)"
                               (clear)="SellerAccountChange($event)"
                               [searchFn]="sellerSearchFn">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">

                        <div class="dropdown-template">
                          <div class="row">
                            <div class="col-md-8">
                              <p class="name" [ngOptionHighlight]="search">
                                {{item.accountName}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                        <div class="ng-option disabled">
                          No data found for "{{searchTerm}}"
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="tabNode==='delivery'" class="deliveryDate">
              <div class="tab-content-heading">
                For: {{SelGrowerObj?.growerName}}
              </div>
              <div class="tab-content-detail">
                <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                  <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused"
                        [class.bg-primary]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                    {{date.day}}
                  </span>
                </ng-template>
                <div class="btn-Sec text-center">
                  <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)" id="btnSaveDeliveryDate">Save</button>
                </div>
              </div>
            </div>
            <div *ngIf="tabNode==='PO'" class="po-No">
              <div class="tab-content-heading">
                For: {{SelGrowerObj?.growerName}}
              </div>
              <div class="tab-content-detail padding-l0 padding-r0 padding-b0">
                <input type="text" [(ngModel)]="customerPONo" [value]="customerPONo" placeholder="Enter PO No." />
                <div class="btn-Sec">
                  <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('customerpo',customerPONo)" id="btnSaveCustomerPO">Save</button>
                </div>
              </div>
            </div>
            <div *ngIf="tabNode==='delete'" class="delete-product">
              <div class="tab-content-heading">
                For: {{SelGrowerObj?.growerName}}
              </div>
              <div class="tab-content-detail">
                <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                <div class="btn-area">
                  <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',true)" id="btnDeleteItemsFromOrder">Yes</button>
                  <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',false)">No</button>
                </div>
              </div>
            </div>
            <div *ngIf="tabNode==='banned'">
              <div class="tab-content-heading">
                For: {{SelGrowerObj?.growerName}}
              </div>
              <div class="tab-content-detail">
                <div class="btn-area">
                  <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="openChangeProductSliderModel('PackageSize')">Package Size</button>
                  <button mat-raised-button class="btns normal-large-btn margin-l10 margin-r10" color="primary" (click)="openChangeProductSliderModel('SeedSize')">Seed Size</button>
                  <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="openChangeProductSliderModel('Treatment')">Treatment</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-filter-outer" [ngClass]="disableOnLock || disablecheckbox || isReadOnly || accessTypeMode ? 'margin-l0' : ''">
        <div class="product-filter col-md-12 margin-l" [ngClass]="disableOnLock || disablecheckbox || isReadOnly || accessTypeMode ? '' : 'widthNinetyThree'" *ngIf="!editToolKit || selectedCount<=0 || isSearchClicked">
          <div class="search-category">
            <div class="brand-dropdown default-select">
              <ng-select [items]="searchTypeList"
                         name="ddlProductSearch"
                         [(ngModel)]="productSearchFilter"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         bindLabel="name"
                         bindValue="value"
                         [searchable]="false"
                         (change)="keepFilter()"
                         placeholder="Select Category">
              </ng-select>
            </div>
          </div>
          <div class="search-box">
            <div class="row margin-0">
              <div class="default-select select-container">
                <div *ngIf="productSearchFilter === 'ProductNameFilter'">
                  <div class="searchInputBox">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="selectProductName($event)" (blur)="selectProductName($event)" [(ngModel)]="productFilters.ProductNameFilter" placeholder="Search Order">
                    </div>
                  </div>
                </div>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                           [items]="marketingMasterList"
                           placeholder="Search Order"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.MarketingBrandList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'seedSize'"
                           [items]="seedsizeMasterList"
                           placeholder="Search Order"
                           [multiple]="true"
                           [hideSelected]="true"
                           class="custom-select-grower"
                           [(ngModel)]="productFilters.SeedSizeList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'packageSize'"
                           [items]="packagesizeMasterList"
                           placeholder="Search Order"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.PackageSizeList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <div *ngIf="productSearchFilter === 'technology'">
                  <div class="searchInputBox">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="selectTechnology($event)" (blur)="selectTechnology($event)" [(ngModel)]="productFilters.TechnologyList" placeholder="Search Order">
                    </div>
                  </div>
                </div>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'treatment'"
                           [items]="treatmentMasterList"
                           placeholder="Search Order"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.TreatmentList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'productLine'"
                           [items]="productLineMasterList"
                           placeholder="Search Order"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ProductLineList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <div class="col-md-6 maturitySelect" *ngIf="productSearchFilter === 'maturity'">
                  <ng-select #productSearch name="ddlproductSearch"
                             [items]="maturityMasterList"
                             placeholder="Min"
                             class="custom-select-grower "
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.MaturityMin"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter()">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-6 maturitySelect" *ngIf="productSearchFilter === 'maturity'">
                  <ng-select #productSearch name="ddlproductSearch"
                             [items]="maturityMasterList"
                             placeholder="Max"
                             class="custom-select-grower"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.MaturityMax"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter()">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row chips-sec" *ngIf="(!editToolKit || selectedCount<=0 || isSearchClicked) && filterValueList != '' ">
          <div class="col-9 selected-chip">
            <mat-chip-set>
              <mat-chip selected *ngFor="let filterValue of filterValueList">
                {{filterValue}}
                <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                  <i class="fas fa-times text-right"></i>
                </a>
              </mat-chip>
            </mat-chip-set>
          </div>
          <div class="col-3 text-right" *ngIf="filterValueList.length > 0">
            <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-12 text-right">
      <div class="row">
        <div class="col-md-1 d-none d-md-block text-left padding-l0">
          <ul class="padding-t10">
            <li *ngIf="selectedCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
              <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'"></i>
            </li>
          </ul>
        </div>
        <div class="col-md-7 col-sm-12 px-3 p-md-0 mb-1 mb-md-0">
          <span [matTooltip]="hybridErrorToolTip"
               [matTooltipDisabled]="!hybridErrorToolTip"
               [matTooltipPosition]="'above'">
            <button mat-raised-button [style.display]="disableOnLock || isReadOnly || accessTypeMode || isMobile ? 'none' : 'inline-block'"
                    class="btns wide100 add-product-btn addReservation" color="primary" [disabled]="enableAddProduct || disabledHybridVariety" (click)="OpenAddHybridProductSlider()" id="btnGrowerAddHybridProduct">
               Add Product <br> (Hybrid/Variety &amp; Package Level)
            </button>
          </span>
        </div>
        <div class="col-md-4 col-sm-12">
          <button mat-raised-button [style.display]="disableOnLock || isReadOnly || accessTypeMode ? 'none' : 'inline-block'"
                  class="btns wide100 add-product-btn" color="primary" [disabled]="enableAddProduct" (click)="openSliderModel()" id="btnGrowerAddProduct">
            Add Product
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 smallPadLR5">
      <div class="tableContainer">
        <table mat-table [dataSource]="growerOrderDS" multiTemplateDataRows class="matTables addGrowerMobile">
          <ng-container matColumnDef="{{column
            }}" *ngFor="let column of columnsToDisplay">
            <div *ngIf="column=='checkbox' && !disableOnLock">
              <th mat-header-cell *matHeaderCellDef class="CheckBoxCol">&nbsp;</th>
            </div>
            <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="productName">Product</th></div>
            <!--<div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="seedSizeHead text-left">Item#</th></div>-->
            <div *ngIf="column=='seedSize'"><th mat-header-cell *matHeaderCellDef class="seedSizeHead text-center">Seed Size</th></div>
            <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
            <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="packageSize text-center">Package Size</th></div>
            <div *ngIf="column=='technology'"><th mat-header-cell *matHeaderCellDef class="technology text-center">Technology</th></div>
            <div *ngIf="column=='dealerUnits'"><th mat-header-cell *matHeaderCellDef class="availableUnits text-center">Available Units</th></div>
            <div *ngIf="column=='longShort'"><th mat-header-cell *matHeaderCellDef class="longShortHead text-center">Long/(Short)</th></div>
            <!--<div *ngIf="column=='maturity'"><th mat-header-cell *matHeaderCellDef class="maturityHead text-center">Maturity</th></div>-->
            <div *ngIf="column=='geu'"><th mat-header-cell *matHeaderCellDef class="units text-center">Units</th></div>
            <div *ngIf="column=='delivery'"><th mat-header-cell *matHeaderCellDef class="deliveryDate text-center">Delivery</th></div>
            <td mat-cell *matCellDef="let element; let i = dataIndex;" (click)="showDetails($event, element,column)">
              <div *ngIf="column=='checkbox'" class="text-center" matTooltip="Select Line" [matTooltipPosition]="'above'" [ngClass]="(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend'))) ? '':'product-row-check'">
                <mat-checkbox #SingleCheck
                              [style.display]="(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))  ? 'none' : 'inline-block'"
                              class="custom-checkbox"
                              [disabled]="isReadOnly || accessTypeMode"
                              (change)="activeEditToolKit(SingleCheck._checked)"
                              [(ngModel)]="element.isSelected" style="display:none;"></mat-checkbox>
                <div class="unavailable-block-Sec" *ngIf="(element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend'))">
                  <div id="main_{{element.rowId}}" class="unavailable-block-outer">
                    <span class="unavailable-block">
                      <i class="icon-ico-Banned_Circle handCursor" (mouseover)="blockHideShow(element.rowId, true)" (mouseout)="blockHideShow(element.rowId, false)"></i>
                    </span>
                    <div class="unavail-content" id="sub_{{element.rowId}}">
                      <h4>This item is currently unavailable for ordering.</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='product'" class="order-info margin-sm-l20" [attr.data-testid]="element.itemNumber">
                <div class="row">
                  <div class="d-block d-md-none padding-l5">Product</div>
                  <div class="col-md-11 padding-l5" matTooltip="{{element.brand}} - {{element.marketingBrand}} #{{element.itemNumber}}" [matTooltipPosition]="'above'">
                    <div class="bold" [attr.data-testid]="element.itemNumber"> {{element.brand}} - {{element.marketingBrand}}</div>
                    <div class="bold d-block d-md-none">{{element.itemDescription}}</div>
                    <div *ngIf="element.seedNonReturnable" class="bold d-block nonReturnable">*NON-RETURNABLE</div>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='seedSize'" class="order-info text-center">
                <div class="row">
                  <div class="col-md-11 padding-l10" matTooltip="{{element.seedSize}}" [matTooltipPosition]="'above'">
                    <div class="bold text-center">{{element.seedSize}}</div>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='treatment'" class="order-info text-center">
                <div class="row">
                  <div class="col-md-11 padding-l20">
                    <span matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'">
                      <strong>{{element.treatment}}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='packageSize'" class="order-info text-center">
                <div class="row">
                  <div class="col-md-11 padding-l15">
                    <span matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'">
                      <strong>{{element.packageSize}}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='technology'" class="order-info text-center">
                <div class="row">
                  <div class="col-md-11 padding-l15">
                    <span matTooltip="{{element.technology}}" [matTooltipPosition]="'above'">
                      <strong>{{element.technology}}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='geu'" class="text-md-center text-sm-start">
                <div class="d-block d-md-none margin-b20 text-center">Units</div>
                <div class="text-center" *ngIf="!(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))">
                  <button *ngIf="!(isReadOnly || accessTypeMode)" (click)="geuValueChange('decrease',element);element.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.itemNumber"> - </button>
                  <input [readonly]="isReadOnly || accessTypeMode"
                         [matTooltip]="element.initialGEU ? 'Dealer Order Units Original ' + (element.initialGEU | number) : ''"
                         [matTooltipPosition]="'above'"
                         matTooltipClass="seed-quantitiy-tooltip"
                         id="txtUnits"
                         type="text"
                         class="geu-txt unitsText wi-70"
                         [(ngModel)]="element.geu"
                         [ngClass]="{'invalid-txt': (element.geu==0 && element.growerOrderItemId==0)}"
                         (focus)="validateSelectedCount(element)"
                         (focusout)="validateItem(element)"
                         maxlength="9"
                         appThreeDigitDecimaNumber
                         (keyup)="geuTextChange(element)"
                         [attr.data-testid]="'qty-' + element.itemNumber" />
                  <button *ngIf="!(isReadOnly || accessTypeMode)" (click)="geuValueChange('increase',element); element.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.itemNumber"> + </button>
                </div>
                <div *ngIf="(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))" class="unitsText text-center">
                  {{commonService.getFormatedNumber(element.geu) | number}}
                </div>
              </div>
              <div *ngIf="column=='dealerUnits'" class="text-md-center unitsText text-sm-start">
                <div class="d-block d-md-none fontSize text-center">Available Units</div>
                <div class="text-center">
                  {{element.seedAvailability | number}}
                </div>
              </div>
              <div *ngIf="column=='longShort'" class="text-center unitsText">

                <div class="d-block d-md-none fontSize text-center">Long/(Short)</div>
                <div>
                  <span *ngIf="element.longShortPosition>=0" class="text-center">{{commonService.getFormatedNumber(element.longShortPosition) | number}}</span>
                  <span *ngIf="element.longShortPosition<0" class="text-center oval-shape treatment"> ({{commonService.getFormatedNumber(element.longShortPosition | positiveValue) | number}})</span>
                </div>
              </div>
              <div *ngIf="column=='delivery'" class="text-center deliveryDatePicker">
                <div class="d-block d-md-none text-center">Delivery</div>
                <mat-form-field [class.invalid-field]="element.desiredDeliveryDate?false:true">
                  <input [readonly]="(isReadOnly || accessTypeMode || disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))" matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter"
                         [(ngModel)]="element.desiredDeliveryDate" disabled (dateChange)="validateDate(element)">
                  <mat-datepicker-toggle [id]="'ddl-date-picker_'+i" matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker [disabled]="(isReadOnly || accessTypeMode || disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))"></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details noPadding" *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
                <div class="warningMsg" *ngIf="element.showCutCancelOverWarning">
                  <div class="row">
                    <div class="col-md-12">
                      {{cutCancelCancellationMessage}}
                    </div>
                  </div>
                </div>
                <div class="newlineMsg" *ngIf="element.growerOrderItemId == 0">
                  <div class="row">
                    <div class="col-md-9 col-lg-10">
                      <p>
                      </p>
                    </div>
                    <div class="col-md-3 col-lg-2 text-right newitem">
                      <p>
                        New Line Item
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row padding-t15 padding-b15 margin-l20 margin-r20 countBlock justify-content-center" [style.display]="element.isSelected ? 'flex' : 'none'">
                  <div class="addBg">
                    <p>Long/(Short)</p>
                    <p class="fontSize">
                      <span *ngIf="element.longShortPosition>=0">{{commonService.getFormatedNumber(element.longShortPosition) | number}}</span>
                      <span *ngIf="element.longShortPosition<0"> ({{commonService.getFormatedNumber(element.longShortPosition | positiveValue) | number}})</span>
                    </p>
                  </div>
                  <div class="addBg">
                    <p>Grower Units</p>
                    <p class="fontSize fontColor">{{commonService.getFormatedNumber(element.netGEU) | number}}</p>
                  </div>
                  <div class="addBg margin-sm-r0">
                    <p>Dealer Units</p>
                    <p class="fontSize">{{element.netBEU | number}}</p>
                  </div>
                  <div class="addBg">
                    <p>Dealer Modifiable Units</p>
                    <div class="DMU fontSize">
                      <span *ngIf="element.dealerModifiableUnits>=0" [ngbPopover]="popContent" [popoverTitle]="popTitle" triggers="mouseenter:mouseleave" class="handCursor">
                        {{element.dealerModifiableUnits | number}}
                      </span>
                      <span *ngIf="element.dealerModifiableUnits<0" [ngbPopover]="popContent" [popoverTitle]="popTitle" triggers="mouseenter:mouseleave" class="handCursor">
                        ({{element.dealerModifiableUnits | positiveValue | number}})
                      </span>

                      <ng-template #popContent>
                        <div class="PopOverContent">
                          <div class="row">
                            <div class="col-md-6">Shipped:</div>
                            <div class="col-md-6 text-right bold">
                              <span *ngIf="element.shippedUnits >= 0" class="hoverDMU">
                                {{element.shippedUnits-element.stockTransferUnits}}
                              </span>
                              <span *ngIf="element.shippedUnits < 0" class="hoverDMU">
                                ({{(element.shippedUnits-element.stockTransferUnits) | positiveValue | number}})
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">Planned:</div>
                            <div class="col-md-6 text-right bold">
                              <span *ngIf="element.plannedUnits >= 0" class="hoverDMU">
                                {{element.plannedUnits}}
                              </span>
                              <span *ngIf="element.plannedUnits < 0" class="hoverDMU">
                                ({{element.plannedUnits | positiveValue | number}})
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">Transferred:</div>
                            <div class="col-md-6 text-right bold">
                              <span *ngIf="element.stockTransferUnits >= 0" class="hoverDMU">
                                {{element.stockTransferUnits}}
                              </span>
                              <span *ngIf="element.stockTransferUnits < 0" class="hoverDMU">
                                ({{element.stockTransferUnits | positiveValue | number}})
                              </span>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template #popTitle>
                        <div class="row">
                          <div class="col-md-8">Dealer Modifiable Units</div>
                          <span class="col-md-4 text-right hoverDMU" *ngIf="element.dealerModifiableUnits>=0">{{element.dealerModifiableUnits | number}}</span>
                          <span class="col-md-4 text-right hoverDMU" *ngIf="element.dealerModifiableUnits<0">{{element.dealerModifiableUnits | positiveValue | number}}</span>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="addBg margin-sm-r0">
                    <p>My Dealer Bucket</p>
                    <p class="fontSize">
                      <span *ngIf="element.myDealerBucket>=0">{{commonService.getFormatedNumber(element.myDealerBucket) | number}}</span>
                      <span *ngIf="element.myDealerBucket<0">({{commonService.getFormatedNumber(element.myDealerBucket | positiveValue) | number}})</span>
                    </p>
                  </div>
                </div>
                <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                        </li>
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="RevertToPrevious(element,true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="seller-info">
                  <div class="row">
                    <div class="col-md-1 col-3 padding-r0 text-md-right text-sm-left">
                      <span class="seller-name padding-r10">Seller:</span>
                    </div>
                    <div class="col-md-4 col-9" *ngIf="(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))">
                      <div class="customer-po-input">
                        <mat-form-field class="example-full-width">
                          <input matInput [disabled]="(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))" [(ngModel)]="element.b2BSellerName" [value]="element.b2BSellerName">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4 col-9 padding-l0" *ngIf="!(disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))">
                      <div class="seller-dropdown default-select">
                        <ng-select [items]="sellerData"
                                   [disabled]="(isReadOnly || accessTypeMode || disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))"
                                   [virtualScroll]="true"
                                   bindLabel="accountName"
                                   bindValue="accountNumber"
                                   placeholder="Search for Seller"
                                   [(ngModel)]="element.sellerID"
                                   class="custom-select-grower"
                                   (change)="GridSellerChange($event, element)"
                                   (clear)="SellerAccountChange($event)"
                                   [searchFn]="sellerSearchFn">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <!--<b [ngOptionHighlight]="search"></b>-->
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name" [ngOptionHighlight]="search">
                                    {{item.accountName}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-md-6 col-10">
                      <span class="customer-po">
                        Customer PO#:
                      </span>
                      <div class="customer-po-input">
                        <mat-form-field class="example-full-width">
                          <input matInput
                                 [disabled]="(isReadOnly || accessTypeMode || disableOnLock || (element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))"
                                 [(ngModel)]="element.customerPO" [value]="element.customerPO"
                                 [maxLength]="maxlength" (change)="GridCustomerPoChange($event.target.value, element)" (focusout)="validateOrder('CustomerPO')">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-1 col-2 text-center line-license-warning" *ngIf="isLineUnlicensed(element)">
                      <i class="fas fa-exclamation-triangle unlicensed-icon" aria-hidden="true" matTooltip="Unlicensed" [matTooltipPosition]="'above'"></i>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true;" class="d-none d-md-table-row"></tr>
            <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row border-0"></tr>
            </table>
            <div *ngIf="filteredDataCount == 0" class="emptyBlock d-block d-md-none">
              <div class="row padding-10">
                <div class="col-6 text-center">Product</div>
                <div class="col-6 text-center"></div>
                <div class="col-6 text-center">Available Units</div>
                <div class="col-6 text-center">Long/(Short)</div>
                <div class="col-6 text-center">Units</div>
                <div class="col-6 text-center">Delivery</div>
              </div>
            </div>
            <div class="tableTotalsSec">
              <div class="row">
                <div class="col-4 col-md-8 padding-l55 padding-sm-l15">Product Totals:</div>
                <div class="col-4 col-md-3 text-right padding-r70 padding-sm-r0">{{filteredDataCount}}  Products</div>
                <div class="col-4 col-md-1 text-left padding-l0 padding-sm-l15">{{commonService.getFormatedNumber(bagCount) | number}} Bags</div>
              </div>
            </div>
             <div class="license-action-required" *ngIf="hasUnlicensedItems && licenseActionMessageHtml">
               <p class="d-flex">
                 <i class="fas fa-exclamation-triangle unlicensed-icon" aria-hidden="true"></i>
                 <span [innerHTML]="licenseActionMessageHtml" (click)="onLicenseActionLinkClick($event)"></span>
               </p>
             </div>
</div>
  </div>
</div>
<div class="row saveBtnsSec" *ngIf="!IsMobile && hasChangeAdded && !isInvalidEmail">
  <div class="col-md-12" *ngIf="buttonType == 'add'" [style.display]="isBusy ? 'none' : 'block'">
    <button type="button" mat-raised-button class="btns submitBtns margin-r15 wide-sm-100 w140 font-sm-14" [style.display]="(disableOnLock) || growerOrderDS.data.length<=0 ? 'none' : 'inline-block'" color="primary" (click)="UpdateGrowerOrder()" id="btnPlaceGrowerOrder">Place Order</button>
    <a (click)="CancelGrowerOrder()" href="javascript:void(0)" id="btnCancel">Cancel </a>
  </div>
  <div class="col-md-12" *ngIf="buttonType == 'edit'" [style.display]="isBusy ? 'none' : 'block'">
    <button type="button" mat-raised-button class="btns submitBtns margin-r15 wide-sm-100 w140 font-sm-14" [style.display]="(disableOnLock) || growerOrderDS.data.length<=0 ? 'none' : 'inline-block'" [disabled]="!hasChangeAdded" color="primary" (click)="UpdateGrowerOrder()">Update Order</button>
    <a (click)="CancelGrowerOrder()" href="javascript:void(0)">Cancel </a>
  </div>
</div>
<div class="row saveBtnsSec" *ngIf="IsMobile">
  <div class="col-md-12 p-0 btnSection" *ngIf="buttonType == 'add'" [style.display]="isBusy ? 'none' : 'block'">
    <div class="d-md-block d-flex justify-content-between">
      <button mat-raised-button class="btns submitBtns margin-r10 font-sm-14" color="primary" (click)="backToOrder()" [style.display]="isBusy ? 'none' : 'inline-block'" [disabled]="hasChangeAdded">Back</button>
      <button *ngIf="hasChangeAdded && !isInvalidEmail" type="button" mat-raised-button class="btns submitBtns w140 font-sm-14" [style.display]="(disableOnLock) || growerOrderDS.data.length<=0 ? 'none' : 'inline-block'" color="primary" (click)="UpdateGrowerOrder()" id="btnPlaceGrowerOrder">Place Order</button>
    </div>
    <a *ngIf="hasChangeAdded && !isInvalidEmail" (click)="CancelGrowerOrder()" href="javascript:void(0)" id="btnCancel">Cancel </a>
  </div>
  <div class="col-md-12 p-0 btnSection" *ngIf="buttonType == 'edit'" [style.display]="isBusy ? 'none' : 'block'">
    <div class="d-md-block d-flex justify-content-between">
      <button mat-raised-button class="btns submitBtns margin-r10 font-sm-14" color="primary" (click)="backToOrder()" [style.display]="isBusy ? 'none' : 'inline-block'" [disabled]="hasChangeAdded">Back</button>
      <button *ngIf="hasChangeAdded && !isInvalidEmail" type="button" mat-raised-button class="btns submitBtns w140 font-sm-14" [style.display]="(disableOnLock) || growerOrderDS.data.length<=0 ? 'none' : 'inline-block'" [disabled]="!hasChangeAdded" color="primary" (click)="UpdateGrowerOrder()">Update Order</button>
    </div>
    <a *ngIf="hasChangeAdded && !isInvalidEmail" (click)="CancelGrowerOrder()" href="javascript:void(0)">Cancel </a>
  </div>
</div>
</div>
